import React from 'react';
import List from '@mui/material/List';
import { ListItemButton, Divider } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
const ListHtmlRenderer = (props) => {
    const items = props.listItems;
    const use_public_storage = props.useStorageUrl ? props.useStorageUrl : false;
    const handleToggle = (value) => () => {
        window.open('/blog/' + value.slug);
    };
    const getAvatar = function (item) {
        if (!item.image) {
            return (React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, { alt: "Remy Sharp" })));
        }
        if (item.image_hash_url && use_public_storage) {
            return (React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, { alt: "Remy Sharp", src: item.image_hash_url })));
        }
        else {
            return (React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, { alt: "Remy Sharp", src: item.image })));
        }
    };
    return (React.createElement(List, { sx: { width: '100%', bgcolor: 'background.paper', opacity: "0.75" } }, items.map((item, index) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(ListItemButton, { key: index, onClick: handleToggle(item), dense: true },
                getAvatar(item),
                React.createElement(ListItemText, { primary: React.createElement(Typography, { sx: { display: 'inline' }, component: "span", variant: "body2", color: "text.primary" }, item.title), secondary: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { sx: { display: 'inline' }, component: "span", variant: "body2", color: "text.primary" }, item.description)) })),
            React.createElement(Divider, null)));
    })));
};
export default ListHtmlRenderer;
//# sourceMappingURL=ListHtmlRenderer.js.map